import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import DataTable from "../../../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../../../Student/Reusablecomponents/Loading";
import { useSelector, useDispatch } from "react-redux";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa";
import ScenarioQuestionformat from "../../../Student/Reusablecomponents/ScenarioQuestionformat";
import notify from "../../../ReusableComponents/ToastifyAlerts";
import { HiMiniPlusSmall } from "react-icons/hi2";
import Search from "../../../ReusableComponents/Search";
import { QuestionData } from "../../../Redux/Reducers/QBAdmin/EditQuestions";
import { ScenarioData } from "../../../Redux/Reducers/QBAdmin/Editscenario";
import {
  ViewVerificationQStatus,
  QuestionPreview,
  ViewQuestionStatus,
} from "../../../ReusableComponents/CommonApis";
import {
  QuestionDelete,
  GetEnglishQuestionDetails,
} from "../../../ReusableComponents/CommonApis";
import { FaClockRotateLeft } from "react-icons/fa6";
const HDirectQuestions = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const PagnatioNumber = useSelector((state) => state.PaginationNo);
  const PNumber =
    PagnatioNumber?.Location === location.pathname &&
    PagnatioNumber?.PageNumber;

  const SearchQuestion = useSelector(
    (state) => state.QuestionDeatils.QuestionDetails
  );

  const [SearchText, SetSearchText] = useState(localStorage.getItem("SearchQId") || "");

  const [DQuestions, SetDQuestions] = useState(props.data);
  const [PageCount, SetPageCount] = useState(10);
  const [CPage, SetCPage] = useState(PNumber || 1);
  const [StatusData, SetStatusData] = useState();
  const [QuestionsData, SetQuestionData] = useState();
  const [Load, SetLoad] = useState(false);
  const [DMessage, SetDMessage] = useState();

  const GetDirectquestions = async (PageNo, test) => {
    dispatch(QuestionData({ QuestionDetails: "" }));
    SetSearchText([]);
    SetCPage(PageNo);
    SetLoad((prev) => !prev);

    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetNonScenarioQuestions?SubjectId=${items?.subjectId}&pageno=${PageNo}&pagesize=${PageCount}&Filter=0&QBCategoryType=NONSCQ&LanguageId=${SelectLanguage} `,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetDQuestions(res.data);
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if(SearchText?.length > 0){
      GetsearchQuestion();
    } else
    if (!props.data) {
      GetDirectquestions(CPage);
    } else if (DMessage) {
      props.Filtersfunction();
    }
  }, [PageCount, DMessage, SelectLanguage]);
  const HandleQuestionDetails = (Qid) => {
    if(SearchText?.length > 0){
      localStorage.setItem("SearchQId", SearchText);
    }
    localStorage.setItem("ERCG",false);
    GetEnglishQuestionDetails(Qid, dispatch, navigate, SetLoad, location, true);
  };

  const columns = [
    {
      name: "Question No(Id)",
      selector: "questionID",
      sortable: true,
      cell: (row) => (
        <div
          className="LinkStyles"
          title="Edit Question"
          onClick={() => HandleQuestionDetails(row.questionID)}
        >
          {row.questionID}{" "}
        </div>
      ),
    },
    {
      name: "Question",
      selector: "question",
      cell: (row) => (
        <div className="ScenarioList">
          <ScenarioQuestionformat scenario={row.question} />
          {row.qType !== "D" &&
            // <div className="Options dflex"> <b>Answer :</b> <ScenarioQuestionformat scenario={row.answer} /> </div> :
            ["A", "B", "C", "D"].map((option, i) => (
               <>
               {row?.[`option${option}`] &&  <div
                key={i}
                className="Options"
                style={
                  option === row.answer
                    ? { color: "green", fontWeight: "bold" }
                    : {}
                }
              >
                <span className="dflex p-1">
                  {option})&nbsp;{" "}
                  <ScenarioQuestionformat scenario={row[`option${option}`]} />{" "}
                </span>
              </div>}</>
            ))}
        </div>
      ),
    },
    {
      name: "Answer(s)",
      selector: "option",
      sortable: true,
      cell: (row) => (
        <div className="dflex">
          {row.qType === "D" ? (
            <ScenarioQuestionformat scenario={row.answer} />
          ) : (
            <span className="dflex p-1">
              {row.answer}) &nbsp;
              <ScenarioQuestionformat
                scenario={row[`option${row.answer}`]}
              />{" "}
            </span>
          )}
        </div>
      ),
    },
    {
      name: "Used/Unused - Mapped/UnMapped",
      selector: "qStatus",
      sortable: true,
    },
    // { name: 'Title', selector: "qStatus", sortable: true, },
    {
      name: "Question Verification Status",
      selector: "qbStatus",
      sortable: true,
      cell: (row) => (
        <div className="dflex flexd-column">
          <span>{row.qbStatus}</span>
          <span
            className="LinkStyles"
            style={{ textWrap: "nowrap" }}
            onClick={() => SetStatusData(row.questionID)}
          >
            {" "}
            View Status Log{" "}
          </span>
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div
          className="dflex CPointer alignitems"
          style={{ gap: "15px", justifyContent: "center" }}
        >
          <FaRegEye
            title="Preview"
            onClick={() =>{
               if(SearchText?.length > 0){
      localStorage.setItem("SearchQId", SearchText);
    }
    QuestionPreview(row, dispatch, navigate, location, true)
            }
            }
          />
          {/* .questionID */}
          <RiDeleteBin5Line
            title="Delete"
            style={{ color: "#FD3333" }}
            onClick={() => {
              SetDMessage();
              QuestionDelete(row.questionID, SetDMessage, dispatch, location);
            }}
          />{" "}
          <span
            className="LinkStyles"
            style={{ textWrap: "nowrap" }}
            onClick={() => SetQuestionData(row.questionID)}
            title="View Question Activity Log"
          >
            <FaClockRotateLeft />
          </span>
        </div>
      ),
    },
  ];

  const DAUQuestions = () => {
    dispatch(QuestionData({ QuestionDetails: "" }));
    navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", {
      state: { Tab: location.state?.Tab, APath: location.pathname },
    });
    dispatch(ScenarioData({ ScenarioDetails: "" }));
  };
  const BacktoNormaList = () => {
    dispatch(QuestionData({ QuestionDetails: "" }));
    localStorage.removeItem("SearchQId");
    SetSearchText([]);
    GetDirectquestions(CPage);
  };
  const GetsearchQuestion = async () => {
    if (SearchText.length > 0) {
      SetLoad((prev) => !prev);
      await axios
        .get(
          process.env.REACT_APP_API_BASE_URL +
            `/QuestionBank/GetFilterQuestionByQuestionId?QuestionId=${SearchText}&SubjectId=${items?.subjectId}&LanguageId=${SelectLanguage} `,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          SetDQuestions(res.data);
          SetLoad((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      notify("Please enter the atlest one Question Id", "warning");
    }
  };
  return (
    <>
      {!props.data && (
        <>
          {" "}
          <div className="MainHeading">Direct Questions</div>
          <div className="Card mt-2">
            <div className="dflex JSBetween alignitems InputFIlters m-1">
              <label style={{ backgroundColor: "white" }}>Search</label>

              <div>By Question Id </div>

              <Search
                onChange={(e) => SetSearchText(e.replace(/[^0-9]/g, ""))}
                Searchvalue={SearchText}
                placeholder="Enter Question Id"
              />

              <div className="dflex alignitems" style={{ gap: "5px" }}>
                <button className="Buttons" onClick={GetsearchQuestion}>
                  Go
                </button>
                {/* , location, true */}
                <button
                  className={` ${
                    SearchText.length > 0 || SearchQuestion
                      ? "Buttons"
                      : "DisableButton Buttons"
                  }`}
                  disabled={SearchText.length === 0 && !SearchQuestion}
                  onClick={BacktoNormaList}
                >
                  Clear Filters
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      <div className="dflex mt-3 mb-2 alignitems JSBetween">
        <div className="SubHeading">Questions</div>
        {props.data ? (
          <div></div>
        ) : (
          <button className="Buttons AddButton dflex alignitems JCCenter" onClick={DAUQuestions}>
            <HiMiniPlusSmall /> Add Question
          </button>
        )}
      </div>
      <div className="Card">
        {/* SearchQuestion ? SearchQuestion : DQuestions SearchQuestion ? [SearchQuestion] : */}
        {DQuestions && (
          <DataTable
            data={DQuestions}
            columns={columns}
            className="NCLDataTable"
            Dropdownvalues={["10", "25", "50", "100"]}
            TotalRecords={props.data ? "" : DQuestions?.[0]?.totalQuestions}
            CountPage={SetPageCount}
            NoPage={props.data ? "" : CPage}
            ShowPagination="true"
            ShowPagecount="true"
            hitapi={props.data ? "" : GetDirectquestions}
          />
        )}
      </div>
      {StatusData && (
        <ViewVerificationQStatus QId={StatusData} Close={SetStatusData} />
      )}
      {QuestionsData && (
        <ViewQuestionStatus QId={QuestionsData} Close={SetQuestionData} />
      )}
      {DMessage?.open && (
        <div className="Model-Open">
          <div className="Card w-50">
            {" "}
            {DMessage?.message}
            <button
              className="Buttons bg-danger"
              style={{ float: "right" }}
              onClick={() => {
                SetDMessage({ open: false });
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      {Load && <Loading />}
    </>
  );
};
export default HDirectQuestions;
